import { useEffect, useState } from 'react';
import {
    PanelBody,
    Button,
    Modal,
    TextControl,
    SelectControl,
    TextareaControl,
    CheckboxControl,
    RadioControl,
    Spinner,
    __experimentalNumberControl as NumberControl,
    Flex,
    FlexItem,
    FlexBlock,
    FormToggle,
    __experimentalScrollable as Scrollable
} from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { fetchData, saveData } from './api';
const ExcludeTab = ({ openPopup , setActiveTab }) => {
    const [isSaving, setIsSaving] = useState(false);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [modifiedFields, setModifiedFields] = useState({});
    useEffect(() => {
        // Fetch settings from the REST API
        fetchData(gmwcp_wp_ajax.getsettings, gmwcp_wp_ajax.nonce)
            .then((fetchedData) => {
                setData(fetchedData);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                console.error('Error fetching settings:', error);
            });
    }, []);

    const updateField = (field, value) => {
        setData((prevData) => ({
            ...prevData,
            [field]: value,
        }));
         setModifiedFields((prevFields) => ({
            ...prevFields,
            [field]: value,
        }));
    };
    const toggleCheckbox = (fieldName, key) => {
        setData((prevData) => {
            const currentValues = prevData[fieldName] || [];
            const updatedValues = currentValues.includes(key)
                ? currentValues.filter((item) => item !== key) // Remove key if already present
                : [...currentValues, key]; // Add key if not present
            return {
                ...prevData,
                [fieldName]: updatedValues,
            };
        });
        setModifiedFields((prevFields) => ({
            ...prevFields,
            [fieldName]: data[fieldName]?.includes(key)
                ? data[fieldName].filter((item) => item !== key)
                : [...(data[fieldName] || []), key],
        }));
    };

    const saveSettings = () => {
        if (Object.keys(modifiedFields).length === 0) {
            openPopup('No changes to save.');
            return;
        }
        setIsSaving(true);

        saveData(gmwcp_wp_ajax.savedata, gmwcp_wp_ajax.nonce, modifiedFields)
            .then((responseData) => {
                setIsSaving(false);
                if (responseData.success) {
                    openPopup('Settings saved!');
                } else {
                    openPopup('Failed to save settings.');
                }
            })
            .catch((error) => {
                setIsSaving(false);
                console.error('Error saving settings:', error);
                openPopup('Failed to save settings.');
            });
    };
   
    return (
        <PanelBody>
             {loading ? (
                <Spinner />
            ) : (
                <>
                        <table className="GMadminTable">
                            <tr>
                                <th>
                                    <label>Exclude Out of Stock Shop / Category Page</label>
                                </th>
                                <td>
                                    <FormToggle
                                      checked={data.gmwcp_exclude_out_of_stock === 'yes'}
                                      onChange={() =>
                                            updateField('gmwcp_exclude_out_of_stock', data.gmwcp_exclude_out_of_stock === 'yes' ? 'no' : 'yes')
                                        }
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label>Exclude From Category</label>
                                </th>
                                <td>

                                  <Scrollable
                                      scrollDirection="y"
                                      style={{
                                        height: 300
                                      }}
                                    >
                                   {gmwcp_wp_ajax.gmwcpcategory.map((catdata) => (
                                        <CheckboxControl
                                            key={String(catdata.term_id)}
                                            label={catdata.name}
                                            checked={data.gmpcp_exclude_category?.includes(String(catdata.term_id))} // Check if key exists in array
                                            onChange={() => toggleCheckbox('gmpcp_exclude_category', String(catdata.term_id))} // Pass field name and key dynamically
                                        />
                                    ))}
                                   </Scrollable>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label>Include Only User Role</label>
                                </th>
                                <td>

                                 
                                   {Object.entries(gmwcp_wp_ajax.gmwcproles).map(([key, value]) => (
                                        <CheckboxControl
                                            key={key} // Use the key (e.g., 'administrator') as the unique key
                                            label={value.name} // Use the 'name' property from the value object for the label
                                            checked={data.gmpcp_exclude_role?.includes(key)} // Check if the key exists in the array
                                            onChange={() => toggleCheckbox('gmpcp_exclude_role', key)} // Pass field name and key dynamically
                                        />
                                    ))}
                                </td>
                            </tr>
                           
                        </table>
                        
                        <Button isPrimary onClick={saveSettings} disabled={isSaving}>
                            {isSaving ? <Spinner /> : 'Save Settings'}
                        </Button>
                      </>
            )}
        </PanelBody>
    );
};

export default ExcludeTab;

